import React from 'react';
import { ArrowLeft, Phone, Shield, UserPlus } from 'lucide-react';
import { AISummaryCard } from '../components/ui/AISummaryCard';
import { AudioPlayer } from '../components/ui/AudioPlayer';
import { useTheme } from '../contexts/ThemeContext';
interface CallDetailScreenProps {
  onBack: () => void;
}
export function CallDetailScreen({
  onBack
}: CallDetailScreenProps) {
  const {
    isLight
  } = useTheme();
  return <div className="h-full flex flex-col relative" data-id="element-631">
      <div className={`p-4 border-b flex items-center gap-3 sticky top-0 backdrop-blur-2xl z-10 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/50' : 'bg-dark/80 border-white/5'}`} data-id="element-632">
        <button onClick={onBack} className={`p-2 -ml-2 rounded-full border transition-colors ${isLight ? 'text-slate-500 hover:text-slate-900 bg-white/60 backdrop-blur-md border-slate-200' : 'text-zinc-400 hover:text-white bg-white/5 backdrop-blur-md border-white/10'}`} data-id="element-633">
          <ArrowLeft className="w-5 h-5" data-id="element-634" />
        </button>
        <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-635">
          Call Details
        </span>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-6 pb-24" data-id="element-636">
        <div className="flex flex-col items-center text-center mb-6" data-id="element-637">
          <div className={`w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold mb-3 border transition-colors ${isLight ? 'bg-purple-100 text-purple-700 border-purple-200' : 'bg-white/10 backdrop-blur-sm text-white border-white/10'}`} data-id="element-638">
            SM
          </div>
          <h2 className={`text-xl font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-639">
            Sarah Miller
          </h2>
          <p className={isLight ? 'text-slate-500' : 'text-zinc-400'} data-id="element-640">
            +1 (555) 987-6543
          </p>
          <div className={`flex items-center gap-2 mt-2 text-sm ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-641">
            <span data-id="element-642">Feb 10, 2:30 PM</span>
            <span data-id="element-643">•</span>
            <span data-id="element-644">Incoming Call</span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3" data-id="element-645">
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-646">
            <Phone className={`w-5 h-5 ${isLight ? 'text-vexu-600' : 'text-white'}`} data-id="element-647" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-648">
              Call
            </span>
          </button>
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-649">
            <Shield className={`w-5 h-5 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-650" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-651">
              Block
            </span>
          </button>
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-652">
            <UserPlus className={`w-5 h-5 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-653" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-654">
              Contact
            </span>
          </button>
        </div>

        <AISummaryCard summary="Missed call. AI answered and took a message. Caller wants to reschedule meeting to Tuesday." data-id="element-655" />

        <div className={`backdrop-blur-xl border rounded-2xl p-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 shadow-sm' : 'bg-dark-card/60 border-white/10 shadow-lg'}`} data-id="element-656">
          <h3 className={`text-xs font-bold uppercase tracking-wider mb-3 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-657">
            Recording
          </h3>
          <AudioPlayer duration="0:45" data-id="element-658" />
        </div>

        <div data-id="element-659">
          <h3 className={`text-xs font-bold uppercase tracking-wider mb-3 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-660">
            Transcript
          </h3>
          <div className={`backdrop-blur-xl border rounded-2xl p-4 text-sm leading-relaxed space-y-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 text-slate-700 shadow-sm' : 'bg-dark-card/60 border-white/10 text-zinc-300 shadow-lg'}`} data-id="element-661">
            <p data-id="element-662">
              <span className={`font-bold ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-663">
                AI:
              </span>{' '}
              Hi, you've reached Alex's AI assistant. Alex is currently
              unavailable. How can I help you?
            </p>
            <p data-id="element-664">
              <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-665">
                Sarah:
              </span>{' '}
              Hi, this is Sarah. I wanted to see if we could reschedule our
              meeting to next Tuesday?
            </p>
            <p data-id="element-666">
              <span className={`font-bold ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-667">
                AI:
              </span>{' '}
              I can pass that message along. Is there a specific time that works
              best for you?
            </p>
            <p data-id="element-668">
              <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-669">
                Sarah:
              </span>{' '}
              Anytime in the morning works. Please have Alex call me back before
              3 PM if possible.
            </p>
          </div>
        </div>
      </div>
    </div>;
}